//施設一覧からのジャンプ
import { CustomLocationData } from './CustomLocationData';

export class Mover {
    urla;
    urlb;
    urlc;
    urlz;
    place;
    Callback;
    locationData;

    constructor(place, MoveByName) {
        // place: 棟　（a/b/c)
        // MoveByName: 名前指定で場所移動するメソッド
        //const a = 'a';
        //const b = 'b';
        //const c = 'c';
        this.place = place;
        this.Callback = MoveByName;
        this.locationData = new CustomLocationData();
        this.urla = './a.html';
        this.urlb = './b.html';
        this.urlc = './c.html';
        this.urlz = './z.html';

        //リンクの設定
        // A棟
        document.getElementById('a00').addEventListener("click", (e: Event) => {
            this.JumpTo('a', 'a00');
        });
        document.getElementById('a10').addEventListener("click", (e: Event) => {
            this.JumpTo('a', 'a10');
        });
        document.getElementById('a21').addEventListener("click", (e: Event) => {
            //this.JumpTo('a', 'a21');
        });
        this.AddPostText('a21','[作成中]'); //[作成中]の追加
        document.getElementById('a22').addEventListener("click", (e: Event) => {
            this.JumpTo('a', 'a22');
        });
        document.getElementById('a23').addEventListener("click", (e: Event) => {
            this.JumpTo('a', 'a23');
        });
        document.getElementById('a31').addEventListener("click", (e: Event) => {
            this.JumpTo('a', 'a31');
        });
        document.getElementById('a32').addEventListener("click", (e: Event) => {
            this.JumpTo('a', 'a32');
        });
        document.getElementById('a33').addEventListener("click", (e: Event) => {
            this.JumpTo('a', 'a33');
        });
        document.getElementById('a34').addEventListener("click", (e: Event) => {
            //this.JumpTo('a', 'a34');
        });
        this.AddPostText('a34','[作成中]'); //[作成中]の追加
        document.getElementById('a41').addEventListener("click", (e: Event) => {
            this.JumpTo('a', 'a41');
        });
        document.getElementById('a42').addEventListener("click", (e: Event) => {
            this.JumpTo('a', 'a42');
        });

        // B棟
        document.getElementById('b00').addEventListener("click", (e: Event) => {
            this.JumpTo('b', 'b00');
        });
        document.getElementById('b11').addEventListener("click", (e: Event) => {
            this.JumpTo('b', 'b11');
        });
        document.getElementById('b12').addEventListener("click", (e: Event) => {
            this.JumpTo('b', 'b12');
        });
        document.getElementById('b21').addEventListener("click", (e: Event) => {
            this.JumpTo('b', 'b21');
        });
        document.getElementById('b22').addEventListener("click", (e: Event) => {
            this.JumpTo('b', 'b22');
        });
        document.getElementById('b23').addEventListener("click", (e: Event) => {
            this.JumpTo('b', 'b23');
        });
        document.getElementById('b24').addEventListener("click", (e: Event) => {
            this.JumpTo('b', 'b24');
        });
        document.getElementById('b31').addEventListener("click", (e: Event) => {
            this.JumpTo('b', 'b31');
        });
        document.getElementById('b32').addEventListener("click", (e: Event) => {
            this.JumpTo('b', 'b32');
        });
        document.getElementById('b33').addEventListener("click", (e: Event) => {
            this.JumpTo('b', 'b33');
        });
        document.getElementById('b34').addEventListener("click", (e: Event) => {
            this.JumpTo('b', 'b34');
        });

        // C棟
        document.getElementById('c00').addEventListener("click", (e: Event) => {
            this.JumpTo('c', 'c00');
        });
        document.getElementById('c10').addEventListener("click", (e: Event) => {
            this.JumpTo('c', 'c10');
        });
        document.getElementById('c20').addEventListener("click", (e: Event) => {
            this.JumpTo('c', 'c20');
        });
        document.getElementById('c31').addEventListener("click", (e: Event) => {
            this.JumpTo('c', 'c31');
        });
        document.getElementById('c32').addEventListener("click", (e: Event) => {
            this.JumpTo('c', 'c32');
        });
        document.getElementById('c41').addEventListener("click", (e: Event) => {
            this.JumpTo('c', 'c41');
        });
        document.getElementById('c51').addEventListener("click", (e: Event) => {
            this.JumpTo('c', 'c51');
        });
        document.getElementById('c52').addEventListener("click", (e: Event) => {
            this.JumpTo('c', 'c52');
        });
        // 中庭
        document.getElementById('z00').addEventListener("click", (e: Event) => {
            this.JumpTo('z', 'z00');
        });
    }

    public AddPostText(id:string, posttext:string){
        //指定したIDのテキストの末尾にテキストを追加
        document.getElementById(id).textContent = document.getElementById(id).textContent + posttext;
    }

    public JumpTo(targetPlace:string, loc:string){
        if(this.place == targetPlace) {
            //現在と同じ棟の場合
            this.Callback(loc);
        }else{
            //現在と異なる棟の場合
            if(targetPlace == 'a'){
                window.open(this.locationData.AddQueryParam(this.urla, loc), window.name);
            }else if (targetPlace == 'b'){
                window.open(this.locationData.AddQueryParam(this.urlb, loc), window.name);
            }else if (targetPlace == 'c'){
                window.open(this.locationData.AddQueryParam(this.urlc, loc), window.name);
            }else if (targetPlace == 'z'){
                window.open(this.locationData.AddQueryParam(this.urlz, loc), window.name);
            }
        }
    }

}